module.exports = __webpack_public_path__ + "211c187b5fe33fa92a2bac390c891119.png";